import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import TicketCard from '../TicketCard';
import { Link } from 'react-router-dom';
import { PiTicket } from "react-icons/pi";
import { FaCalendarAlt } from "react-icons/fa";
import { ReactComponent as FAQs } from '../../../../../../assets/fonts/faqsvg.svg' 
import PreviousTicketCard from '../NewDesignPreviousTickets/PreviousTicketCardNewDesign'
import './style.css'
import PreviousCardSecton from '../PreviousSection/PreviousCardSecton';
import GenerateTicket from '../NewModalForTicket/GeneratedTicket';
import { CandleStaticAreasOption, Candelmodule } from '../../Staticdata/data';
import AreaService from '../../../../../../api/areaService';
import Loader1 from "../../../../../../CommonElements/Spinner/loader";
import DataTable from 'react-data-table-component';
import { Button, Modal, ModalBody } from 'reactstrap';

const dummy = [
  {
    id: 789,
    module: [
      {
        id: 1,
        name: 'Person Available Alert'
      },
      {
        id: 2,
        name: 'Grouping'
      },
      {
        id: 3,
        name: 'Supervisor presence'
      },
    ],
    generated_by: 'Mr. Fida Khan Shareef',
    issue_date: '1st Jan 2024',
    area: [
      {
        id: 1,
        name: 'MOULDING',
        owner: 'Mr. Fida Khan Shareef',
      },
      {
        id: 2,
        name: 'STORE',
        owner: 'Mr. Kashif Ghani Usman Ghani'
      },
      {
        id: 3,
        name: 'Ali Pump',
        owner: 'Qaiser'
      },
    ],
    sub_area: [
      {
        id: 2,
        name: 'LOCAL STORE'
      },
      {
        id: 1,
        name: 'MOULDING DEPART'
      },
      {
        id: 3,
        name: 'Ali Pump Doubling'
      },
    ],
    priority: 'high',
    query: 'testing 123',
    status: 'pending',

  },
  {
    id: 780,
    module: [
      {
        id: 1,
        name: 'Person Available Alert'
      },

      {
        id: 3,
        name: 'Supervisor presence'
      },
    ],
    generated_by: 'Qaiser',
    issue_date: '2nd Jan 2025',
    area: [
      {
        id: 1,
        name: 'MOULDING',
        owner: 'Mr. Fida Khan Shareef',
      },

      {
        id: 3,
        name: 'Ali Pump',
        owner: 'Qaiser'
      },
    ],
    sub_area: [
      {
        id: 2,
        name: 'LOCAL STORE'
      },


    ],
    priority: 'high',
    query: 'testing 123',
    status: 'in-process',
    response_date: '7th Jan 2025',
    response: 'testing completed'
  },
  {
    id: 781,
    module: [

      {
        id: 2,
        name: 'Grouping'
      },
      {
        id: 3,
        name: 'Supervisor presence'
      },
    ],
    generated_by: 'Kashif, Usman',
    issue_date: '3rd Jan 2025',
    area: [
      {
        id: 2,
        name: 'STORE',
        owner: 'Mr. Kashif Ghani Usman Ghani'
      },
      {
        id: 3,
        name: 'Ali Pump',
        owner: 'Qaiser'
      },
    ],
    sub_area: [

      {
        id: 1,
        name: 'MOULDING DEPART'
      },
      {
        id: 3,
        name: 'Ali Pump Doubling'
      },
    ],
    priority: 'high',
    query: 'testing 123',
    status: 'resolved',
    response_date: '7th Jan 2025',
    response: 'testing completed'
  },
]
const HeroSectionNew = ({ generateTicket, role, AreaMode }) => {
  const [activeFilter, setActiveFilter] = useState('all');
  // const [dataforDisplay, setdataforDisplay] = useState(dummy);
  const [dataforDisplay, setdataforDisplay] = useState([]);
  const [recentData, setrecentData] = useState([]);
  const [modal, setModal] = useState(false);
  const [modalType, setmodalType] = useState('Generate');
  const [factoryID, setfactoryID] = useState(JSON.parse(localStorage.getItem('userData')).factory.id || 0)
  const [type, settype] = useState('');
  const [editCount, seteditCount] = useState(0)
  const [loading, setLoading] = useState(true);
  const [AllOption, setAllOption] = useState({
    areas: [],
    modules: [],
    tickets: []
  })
  // States for detail modal
  const [detailModal, setDetailModal] = useState(false);
  const [selectedDetailTicket, setSelectedDetailTicket] = useState(null);

  // Toggle function for detail modal
  const toggleDetailModal = () => setDetailModal(!detailModal);

  // Function to handle reopen ticket
  const handleReopenTicket = async (row) => {
    console.log("Reopening ticket:", row);
    // Add your reopen logic here
    const payload = {
      user_id: JSON.parse(localStorage.getItem('userData'))?.id,
      ticket_id: row?.id,
      status: 'open',
      response: 'response'
    }
    try {
      const res = await AreaService.handleTicketUpdateReq(payload);
    } catch (error) {
      console.log('error while updating ticket', error)
    }
  }

  // DataTable columns configuration
  const columns = [
    {
      name: 'Ticket ID',
      selector: row => row.id,
      sortable: true,
    },
    {
      name: 'Generated By',
      selector: row => row.owner,
      sortable: true,
    },
    {
      name: 'Issue Date',
      selector: row => row.ticketDate,
      sortable: true,
    },
    {
      name: 'Module',
      cell: row => (
        <div>
          {row.models && row.models.length > 0 ? (
            row.models.slice(0, 2).map((mod) => (
              <span
                key={mod.id}
                className='p-1 mx-1 moduleSubHeading'
                style={{
                  background: '#E9F6FC',
                  borderRadius: '4px',
                  color: '#1E84B0',
                  display: 'inline-block',
                  marginBottom: '2px',
                  fontSize: '12px'
                }}
              >
                {mod.name}
              </span>
            ))
          ) : (
            <span>-</span>
          )}
          {row.models && row.models.length > 2 && (
            <span
              className='p-1 mx-1'
              style={{
                background: '#f0f0f0',
                borderRadius: '4px',
                color: '#666',
                display: 'inline-block',
                marginBottom: '2px',
                fontSize: '12px'
              }}
            >
              +{row.models.length - 2} more
            </span>
          )}
        </div>
      ),
    },
    {
      name: 'Status',
      selector: row => row.status,
      sortable: true,
      cell: row => (
        <span className='ms-2 p-1' style={{
          background: row.status === 'pending' ? '#F7F8F9' :
            row.status === 'in process' ? '#FFF7E6' :
              row.status === 'resolved' ? '#EEF8ED' : '#F7F8F9',
          borderRadius: '4px',
          color: row.status === 'pending' ? 'black' :
            row.status === 'in process' ? '#D99104D9' :
              row.status === 'resolved' ? '#43953B' : 'black'
        }}>
         {row?.status?.charAt(0).toUpperCase() + row?.status?.slice(1)}
        </span>
      )
    },
    {
      name: 'Priority',
      selector: row => row.priority,
      sortable: true,
    },
    {
      name: 'Actions',
      cell: row => (
        <div className="d-flex">
          {(row.status?.toLowerCase() === 'open' || row.status?.toLowerCase() === 'reopen')  && (
            <Button
              className="edit-btn"
              color="secondary"
              size="sm"
              onClick={(e) => {
                e.stopPropagation(); // Prevent row click
                HandleEdit(row);
              }}
            >
              Edit
            </Button>
          )}
          {row.status?.toLowerCase() === 'closed' && (
            <Button
              className="reopen-btn"
              color="warning"
              size="sm"
              onClick={(e) => {
                e.stopPropagation(); // Prevent row click
                HandleEdit(row, 'reopen');
              }}
            >
              Reopen
            </Button>
          )}
        </div>
      ),
    },
  ];
  const [selectedTicket, setselectedTicket] = useState(
    {
      id: '',
      models: [],
      generated_by: JSON.parse(localStorage.getItem('name')),
      issue_date: '3rd Jan 2025',
      areas: [],
      sub_areas: [],
      priority: '',
      query: '',
      status: '',
    }
  )
  // Toggle function to open/close modal
  const toggle = () => {
    // Fix scrollbar issue when toggling modals
    if (modal) {
      document.body.style.overflow = 'auto';
      document.body.style.paddingRight = '0';
    }
    setModal(!modal);
  };

  const handlenavigate = (where_to_go) => {
      sessionStorage.setItem("previousTab", window.location.href);
    window.open(where_to_go, "_blank");
  }
  // generate & Edit tickets----------------x---------------------------
  const HandleEdit = (data, open) => {
    console.log(data)
    const FinalFormat = {
      ...data,
      sub_areas: (data?.sub_areas || []).map(item => ({
        name: item.name,
        id: item.sub_area_id
      })),
      areas: data?.areas.map(item => ({
        ...item,
        label: `${item.name}, ${item.owner}`,
        disabled: false
      })),
      status: open ? 'reopen' : data.status
    }
    setselectedTicket(FinalFormat)
    const modalValue = open ? 'Reopen' : 'Edit'
    setmodalType(modalValue)
    toggle();
  }
  const handleGneretaeTicketModal = () => {
    if (AreaMode) {
      const areaDetails = {
        id: JSON.parse(localStorage.getItem('userData'))?.area_ids.id,
        name: JSON.parse(localStorage.getItem('userData'))?.area_ids.name,
        owner: JSON.parse(localStorage.getItem('userData'))?.name
      }
      console.log(areaDetails)
      setselectedTicket({
        models: [],
        areas: [areaDetails],
        sub_areas: [],
      })
    }
    else {
      setselectedTicket({
        models: [],
        areas: [],
        sub_areas: [],
      })
    }
    toggle();
    setmodalType('Generate');
  }
  // generate & Edit tickets end ----------------x---------------------------


  //  filter functionality --------------x-----------------------------
  const handleButtonClick = (filter) => {
    setActiveFilter(filter);
    if (filter == 'all') {
      setdataforDisplay(AllOption.tickets);
      setrecentData(AllOption.tickets)
    }
    else {
      const filterOutput = AllOption.tickets?.filter(item => item.status == filter);
      console.log(filter)
      console.log(filterOutput, 'after filteration')
      setrecentData(filterOutput)
      setdataforDisplay(filterOutput)
    }
  };
  const handleSearch = (e) => {
    const query = e.toLowerCase()
    if (query === "") {
      setdataforDisplay(recentData);
      return;
    }
    const searchOutput = dataforDisplay.filter(item => {
      if (item.id.toString().includes(query)) return true;

      if (item.owner.toLowerCase().includes(query)) return true;
      if (item.ticketDate.includes(query)) return true;

      if (item.models?.some(mod => mod.name.toLowerCase().includes(query))) return true;

      if (item.areas?.some(area => area.name.toLowerCase().includes(query))) return true;

      if (item.sub_areas?.some(sub => sub.name.toLowerCase().includes(query))) return true;

      return false;
    });
    setdataforDisplay(searchOutput)
  }
  //  filter functionality end --------------x-----------------------------

  const FetchTickets = async () => {
    try {
      const payload = {
        factory_id: factoryID,
        user_id: JSON.parse(localStorage.getItem("userData"))?.id || 41
      }
      const loggedinUserArea = JSON.parse(localStorage.getItem("userData"))?.area_ids
      // AreaService.getAlltickets(payload)

      if (AreaMode) {
        AreaService.getAreaUserTickets(payload).then((resp) => {
          console.log('AreaMode mode', AreaMode);
          console.log('response from api', resp.data);
          const areaa = resp?.data?.data?.areas.filter(e => e && e.area_id === loggedinUserArea.id);
          console.log(areaa, 'filtered area');
          resp?.data?.data?.tickets.forEach((ticket) => {
            ticket.areas = ticket.areas.map((area) => {
              const matchedArea = resp?.data?.data?.areas.find((a) => a.area_id == area.area_id);
              return {
                id: area.area_id,
                name: area.area_name,
                owner: matchedArea ? matchedArea.area_owner : null,
              };
            });
          });
          const formattedModels = resp?.data?.data?.models.map((model) => ({
            id: model.module_id,
            name: model.module_name,
          }));
          setdataforDisplay(resp?.data?.data?.tickets);
          setAllOption({
            areas: areaa,
            modules: formattedModels,
            tickets: resp?.data?.data?.tickets
          })
          setLoading(false)
        }).catch((err) => {
          console.log('error fetching support ticket data', err)
        })
      }
      else {
        AreaService.getAlltickets(payload)
          .then((res) => {
            const resp = res?.data?.data;
            console.log(resp);

            // getting area owner name from all area options
            resp?.tickets.forEach((ticket) => {
              ticket.areas = ticket.areas.map((area) => {
                const matchedArea = resp?.areas.find((a) => a.area_id == area.area_id);
                return {
                  id: area.area_id,
                  name: area.area_name,
                  owner: matchedArea ? matchedArea.area_owner : null,
                };
              });
            });

            // changing module key module_id into id, for typeahead filteration
            const formattedModels = resp?.models.map((model) => ({
              id: model.module_id,
              name: model.module_name,
            }));

            setdataforDisplay(resp?.tickets);
            setAllOption({
              areas: resp.areas,
              modules: formattedModels,
              tickets: resp.tickets
            })
            setLoading(false)
          })
          .catch(() => {
            setLoading(false)
          });
      }
    } catch (error) {
      console.log('error fetching support ticket data', error)
    }
  }
  useEffect(() => {
    //   const updatedArray = dataforDisplay.map(item => {
    //     const updatedArea = item.area.map(areaItem => {
    //       return {
    //         ...areaItem,
    //         label: `${areaItem.name}, ${areaItem.owner}`
    //       };
    //     });
    //     return {
    //       ...item,
    //       area: updatedArea
    //     };
    //   });
    //  setdataforDisplay(updatedArray);
    FetchTickets()
  }, [])
  return (
    <Row>
      {loading ? <Loader1 /> : <>
        <Col xs='12'>
          <div className='cardbackcolor' style={{ height: '256px', background: '#175FA4', borderRadius: '24px' }}>
            <p className='ticketspageheading text-center ' style={{ fontSize: '48px', fontWeight: "600", color: 'white', paddingTop: '70px' }}>Need our help? We’ve got your back</p>
          </div>
          <div className='cardlisting d-flex justify-content-center flex-wrap' style={{ marginTop: '-70px' }} >
            <TicketCard heading={'Generate Support Ticket'} Icon={PiTicket} onClick={() => { handleGneretaeTicketModal() }}
            />
            <TicketCard heading={'Schedule a Meeting Now'} Icon={FaCalendarAlt} onClick={() => handlenavigate('https://calendly.com/m-umair-arif/30min')} />
            <TicketCard heading={'FAQs'} Icon={FAQs} flag={true} onClick={() => handlenavigate(`${process.env.PUBLIC_URL}/support/documentationfaqs/${role}`)} />
          </div>
        </Col>
        <Col xs='12'>
          <Row>

            <div className='d-flex justify-content-between align-items-center flex-wrap mb-2 mt-5 mt-xxl-0 mt-xl-0 mt-lg-0 mt-md-0'>
              <h6 className='mt-3' style={{ color: '#383838', fontSize: '20px', fontWeight: '700' }}>Previous Support Tickets</h6>
              <PreviousCardSecton onClick={handleSearch} />
            </div>

            {/* filters section */}
            <div>
              <button
                className={`filtersbtn px-0 py-2 me-3 ${activeFilter === 'all' ? 'filteractive' : ''}`}
                onClick={() => handleButtonClick('all')}
              >
                All
              </button>
              <button
                className={`filtersbtn px-0 py-2 me-3 ${activeFilter === 'open' ? 'filteractive' : ''}`}
                onClick={() => handleButtonClick('open')}
              >
                Open
              </button>
              <button
                className={`filtersbtn px-0 py-2 me-3 ${activeFilter === 'closed' ? 'filteractive' : ''}`}
                onClick={() => handleButtonClick('closed')}
              >
                Closed
              </button>
              <button
                className={`filtersbtn px-0 py-2 me-3 ${activeFilter === 'reopen' ? 'filteractive' : ''}`}
                onClick={() => handleButtonClick('reopen')}
              >
                Reopened
              </button>
              {/* <button
                className={`filtersbtn px-0 py-2 me-3 ${activeFilter === 'resolved' ? 'filteractive' : ''}`}
                onClick={() => handleButtonClick('resolved')}
              >
                Resolved
              </button> */}
            </div>
            <hr />

            {/* DataTable for tickets */}
            {dataforDisplay?.length <= 0 ? (
              <p className='f-light text-center mt-4'>Zero <b>tickets</b> found</p>
            ) : (
              <DataTable
                columns={columns}
                data={dataforDisplay.sort((a, b) => b.id - a.id)}
                pagination
                highlightOnHover
                responsive
                striped
                pointerOnHover
                onRowClicked={(row) => {
                  setSelectedDetailTicket(row);
                  toggleDetailModal();
                }}
                customStyles={{
                  headRow: {
                    style: {
                      backgroundColor: '#f8f9fa',
                      fontWeight: 'bold',
                    },
                  },
                  rows: {
                    style: {
                      minHeight: '60px',
                    },
                  },
                }}
              />
            )}

            {/* Generate Ticket Modal */}
            <GenerateTicket
              AreaMode={AreaMode}
              seteditCount={seteditCount}
              dataforDisplay={dataforDisplay}
              setdataforDisplay={setdataforDisplay}
              modalType={modalType}
              modal={modal}
              toggle={() => {
                // Ensure body scrolling is properly managed
                if (modal) {
                  document.body.style.overflow = 'auto';
                  document.body.style.paddingRight = '0';
                }
                toggle();
              }}
              modileOptions={AllOption.modules}
              areaOption={AllOption.areas}
              NewTicket={selectedTicket}
              setselectedTicket={setselectedTicket}
            />

            {/* Detail Modal */}
            <Modal
              isOpen={detailModal}
              toggle={toggleDetailModal}
              size="lg"
              className="custom-modal"
              onClosed={() => {
                // Ensure body scrolling is restored when modal is closed
                document.body.style.overflow = 'auto';
                document.body.style.paddingRight = '0';
              }}
            >
              <ModalBody>
                {selectedDetailTicket && (
                  <PreviousTicketCard
                    data={selectedDetailTicket}
                    handleEdit={() => {
                      // Ensure body scrolling is restored before opening edit modal
                      document.body.style.overflow = 'auto';
                      document.body.style.paddingRight = '0';
                      toggleDetailModal();
                      HandleEdit(selectedDetailTicket);
                    }}
                  />
                )}
                <div className="text-center mt-3">
                  <Button
                    color="secondary"
                    onClick={toggleDetailModal}
                    style={{ background: '#175FA4' }}
                  >
                    Close
                  </Button>
                </div>
              </ModalBody>
            </Modal>
          </Row>
        </Col>
      </>}

    </Row>
  );
}

export default HeroSectionNew;
